import React, { useContext } from 'react'

import ClientInformation from './pages/ClientInformation'
import { FormContext } from './context/FormContext'
import Question from './pages/Question'
import Finish from './pages/Finish'

const App = () => {
  const { questionData, authData } = useContext(FormContext)

  const question = questionData?.question
  const isFinish = questionData?.isFinish

  if (!authData?.isAuth) {
    return <ClientInformation />
  } else if (question) {
    return <Question />
  } else if (isFinish) {
    return <Finish />
  }
}

export default App
